import axios from "@/config/axiosConfig";
import {
  SALES_OUTSTANDING_REPORT_REQUEST,
  SALES_OUTSTANDING_REPORT_SUCCESS,
  SALES_OUTSTANDING_REPORT_FAILURE,
  SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_REQUEST,
  SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_SUCCESS,
  SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_FAILURE,
  SALES_OUTSTANDING_REPORT_REQUEST_SUCCESS,
  SALES_OUTSTANDING_REPORT_REQUEST_FAILURE,
  SALES_OUTSTANDING_FILTER_REPORT_REQUEST,
  SALES_OUTSTANDING_FILTER_REPORT_SUCCESS,
  SALES_OUTSTANDING_FILTER_REPORT_FAILURE
} from "../types/sales-outstanding-report-types";
import dayjs from '@/utils/dayjs';

export const getSalesOutstandingRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_OUTSTANDING_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        finStartDate: auth.finyear?.From_Date && dayjs(auth.finyear?.From_Date).format('YYYY-MM-DD'),
      };
      
      const requestParams = { ...defaultParams, ...params };
      const data = requestParams; 
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getSalesReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.post('/outstanding-report/getSalesReport', data, {
        params: defaultParams,
      }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SALES_OUTSTANDING_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Outstanding Report:", error);
        dispatch({ type: SALES_OUTSTANDING_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Outstanding Report:", error);
      dispatch({ type: SALES_OUTSTANDING_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getSalesOutstandingRegisterReportMailWhatsapp = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };
      const data = requestParams; 

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getSalesReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.post('/outstanding-report/getSalesReport', data, {
        params: defaultParams,
      }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_SUCCESS, payload: response.data });
        }
        return response?.data;
      }).catch((error) => {
        console.error("Error fetching Sales Outstanding Report:", error);
        dispatch({ type: SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Outstanding Report:", error);
      dispatch({ type: SALES_OUTSTANDING_REPORT_MAIL_WHATSAPP_FAILURE, error: error.message });
    }
  };
};

export const sendMailSaleOutstanding = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_OUTSTANDING_REPORT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('accountId', mailData.accountId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `sales_outstanding.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/outstanding-report/sales-outstanding-mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_OUTSTANDING_REPORT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_OUTSTANDING_REPORT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_OUTSTANDING_REPORT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappSaleOutstanding = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_OUTSTANDING_REPORT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('accountId', whatsappData.accountId);
      formData.append('brokerId', whatsappData.brokerId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      formData.append('totalBalance', whatsappData.totalBalance || 0);
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `sales_outstanding.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/outstanding-report/sales-outstanding-whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_OUTSTANDING_REPORT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_OUTSTANDING_REPORT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_OUTSTANDING_REPORT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const getSalesOutstandingRegisterReportFilterDetail = (isCommonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: SALES_OUTSTANDING_FILTER_REPORT_REQUEST });
            const { auth } = getState();
            let defaultParams = {};
            if (isCommonMaster) {
                defaultParams = {
                    // companyId: auth.company?.id,
                    customerId: auth.user?.Customer_Id,
                };
            } else {
                defaultParams = {
                    companyId: auth.company?.id,
                    customerId: auth.user?.Customer_Id,
                };
            }
            // const defaultParams = {
            //     companyId: auth.company?.id,
            //     customerId: auth.user?.Customer_Id,
            // };
            const requestParams = { ...defaultParams };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/outstanding-report/getSalesReportFilters?${queryString}`;
            console.log('<<Complete API Request URL: ', fullUrl);
            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                dispatch({ type: SALES_OUTSTANDING_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching sales outstanding Report Filters:", error);
                dispatch({ type: SALES_OUTSTANDING_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching sales outstanding Report Filters:", error);
            dispatch({ type: SALES_OUTSTANDING_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearSalesOutstandingRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: SALES_OUTSTANDING_REPORT_SUCCESS, payload: {} });
  }
}
